module.exports = __webpack_public_path__ + "img/doors-left.0cd67c80.svg";